import { embla } from "javascripts/webpage/embla";

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelectorAll("#js-specials")) {
    return;
  }
  embla("js-embla-slider-image", { autoplay: true });
});
